import { playTick, shouldTick } from '~/utils/tapSound'
import { TAP_EVENT } from '~/utils/tapTolerance'

/**
 * A tick on every tap, app-wide (decision 0010, route A).
 *
 * At the LIFT, not the touchdown — as Android's own click sound is. The tick
 * used to play on pointerdown, so a scroll that began with a finger on an
 * orders row ticked, and a press dragged off a button ticked though the
 * button never fired (user, 2026-09-02). The tap recogniser
 * (tap-tolerance.client.ts) already decides when a press-and-lift was a tap
 * and announces each one as a `dockautomation:tap` event on the control; this
 * plays to that and nothing else. The lift is still inside the user's
 * gesture, so the browser lets the sound through. Keyboard activation is
 * silent, as it is on Android.
 *
 * The rule itself — what counts as a button, disabled means silent, the
 * per-tablet off switch — lives in utils/tapSound.ts, where it is tested.
 */
export default defineNuxtPlugin(() => {
  document.addEventListener(TAP_EVENT, (event) => {
    const target = event.target instanceof Element ? event.target : null
    if (shouldTick(target)) playTick()
  })
})
